import React, { useMemo, useEffect } from 'react';
import useStockPrices from '../../hooks/useStockPrices';
import MetricHighlight from '../MetricHighlight/MetricHighlight';
import style from './PriceChart.module.css';
import { formatCurrency } from '../../helpers/format';
import NoticeableUSInvestors from '../NoticeableUSInvestors/NoticeableUSInvestors';

const PriceChart = ({ stock, hubGurus }) => {
  const { prices, error, isLoading } = useStockPrices(stock.id);
  const lastPrice = prices && prices[prices.length - 1];
  const [w52Min, w52Max] = useMemo(() => {
    if (!prices || prices.length === 0) { return []; }

    const date52w = new Date(lastPrice.date);
    date52w.setDate(date52w.getDate() - (52 * 7))
    const index = prices.findIndex((price) => new Date(price.date) >= date52w);
    const prices52w = prices.slice(index);

    return [
      prices52w.reduce((prev, current) => Math.min(prev, current['close']), Infinity),
      prices52w.reduce((prev, current) => Math.max(prev, current['close']), 0)
    ];
  }, [prices]);

  return (
    <div>
      <div className={style.infoBar}>
        <div className={style.infoBarLeft}>
          <MetricHighlight name="Market Cap">${formatCurrency(stock.market_cap, { compact: true })}</MetricHighlight>
          {w52Min && w52Max &&
            <MetricHighlight name="52-Week Range">
              ${formatCurrency(w52Min)} -
              ${formatCurrency(w52Max)}
            </MetricHighlight>
          }
        </div>
        <div className={style.infoBarRight}>
          <MetricHighlight big name={`${lastPrice ? new Date(lastPrice.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) + ', ' : ''} Close`}>
            ${lastPrice && formatCurrency(lastPrice.close)}
          </MetricHighlight>
        </div>
      </div>

      <Graph stock={stock} />

      <NoticeableUSInvestors stock={stock} hubGurus={hubGurus} price={lastPrice && lastPrice.close} />
    </div>
  );
};

export default PriceChart;

const Graph = ({stock}) => {
  useEffect(() => {
    const init = () => {
      if (typeof window.initOpenOnLoadLineCharts === 'function') {
        window.initOpenOnLoadLineCharts();
      }
    };

    init();
    document.addEventListener('stockcircle:charts-ready', init);
    return () => document.removeEventListener('stockcircle:charts-ready', init);
  }, [stock.id]);

  return (
    <div className="js-line-chart-open-on-load line-chart--stock" dangerouslySetInnerHTML={{
      __html: `
      <div class="line-chart"
        data-show-activity-chart="true"
        data-stock-id="${stock.id}"
        data-stock-symbol="${stock.symbol.toLowerCase()}"></div>
      `}}>
    </div>
  );
}